<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row class="mb-4">
        <v-col cols="12">
          <h2>
            {{ $t("messages.bookAppointmentRequest") }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="appointmentRequestForm">
        <v-row>
          <v-col cols="12">
            <v-select :label="$t('basics.product')" :items="availProducts" v-model="product"
              variant="outlined" flat return-object
              item-title="name"
              item-value="name">
            </v-select>
          </v-col>
        </v-row>
        <v-row v-if="slotData">
          <v-col>
            <div v-html='$t("messages.requestAppointmentInfoText", {
              date: slotData.display_date,
              startTime: slotData.display_start_time,
              endTime: slotData.display_end_time,
              therapist: therapist?.full_name
            })'></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" :loading="loading" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "appointmentRequestComponent",

  props: ["refreshDisplay", "slotData", "therapist"],

  emits: ["close"],

  data() {
    return {
      availProducts: undefined,
      product: undefined,

      loading: false,

      requiredRule: (value) => !!value || this.$i18n.t("messages.required"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),

      validObject: (value) =>
        !value ||
        typeof value == "object" ||
        this.$i18n.t("messages.validSelectionrequired"),

      startDateSmallerRule: (value) =>
        !this.startDate ||
        !this.endDate ||
        this.startDate <= this.endDate ||
        typeof value == "object" ||
        this.$i18n.t("messages.startDateTooBig"),
    };
  },

  watch: {
    refreshDisplay() {
      if (this.refreshDisplay) {
        this.loading = false
      }
    },
  },

  computed: {
  },

  methods: {
    fetchProducts() {
      return new Promise((resolve, reject) => {
        this.axios
          .get(
            this.axios.defaults.baseURL + "media/products/?size=10000&order=is_default"
          )
          .then((resp) => {
            this.availProducts = resp.data.results

            this.product = resp.data.results[0]

            resolve()
          })
          .catch((e) => {
            console.log(e)
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
            reject()
          })
      })
    },
    async confirm() {
      const { valid } = await this.$refs.appointmentRequestForm.validate();

      if (valid) {
        this.loading = true

        let formData = {
          date: this.slotData.date,
          start_time: this.slotData.start_time,
          end_time: this.slotData.end_time,
          therapist: this.therapist.id,
          product: this.product.id
        };

        this.postData(formData);
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "calendar/timeslots/request/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);
          this.loading = false
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },

  mounted() {
    this.fetchProducts();
  },
};
</script>
